"use client";

import React from "react";
import { Mail, MapPin, Send, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-background text-foreground border-t border-border/10">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {}
          <div className="flex flex-col space-y-6">
            <Link to="/HomePage" className="inline-block">
              <span className="text-xl font-bold tracking-tight text-white">
                Агенство ПРОФИ
              </span>
            </Link>
            <p className="text-white text-sm leading-relaxed max-w-xs">
              Экспертиза на каждой полке. Мы создаем эффективные стратегии мерчандайзинга для вашего успеха.
            </p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Быстрые ссылки</h3>
            <nav className="flex flex-col space-y-3">
              {[{
              label: "Главная",
              to: "/HomePage"
            }, {
              label: "Услуги",
              to: "#services"
            }, {
              label: "О компании",
              to: "#about"
            }, {
              label: "Контакты",
              to: "#contact"
            }].map((link, i) => <div key={i} data-index={i}>
                  <Link to={link.to} className="text-muted-foreground hover:text-primary transition-colors duration-300 text-sm flex items-center gap-2 group w-fit">
                    <ArrowRight className="w-3 h-3 opacity-0 -ml-3 group-hover:opacity-100 group-hover:ml-0 transition-all duration-300 text-primary" />
                    {link.label}
                  </Link>
                </div>)}
            </nav>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Контакты</h3>
            <div className="flex flex-col space-y-4 text-sm text-muted-foreground">
              <div className="flex items-start gap-3 group">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5 group-hover:text-primary/80 transition-colors" />
                <span className="leading-relaxed">
                  350011, Краснодарский край, г Краснодар, Старокубанская ул, д. 2/15, помещ. 3
                </span>
              </div>
              <div className="flex items-center gap-3 group">
                <Mail className="w-5 h-5 text-primary shrink-0 group-hover:text-primary/80 transition-colors" />
                <Link to="mailto:agency.profi.krd@yandex.ru" className="hover:text-primary transition-colors duration-300">
                  agency.profi.krd@yandex.ru
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-lg font-semibold tracking-tight">Рассылка</h3>
            <p className="text-sm text-muted-foreground">
              Подпишитесь на наши новости и обновления индустрии.
            </p>
            <div className="flex w-full max-w-sm items-center space-x-2">
              <Input type="email" placeholder="Ваш email" className="bg-input/20 border-input/50 focus-visible:ring-primary/50 h-10" />
              <Button size="icon" className="h-10 w-10 shrink-0 bg-primary hover:bg-primary/90 text-primary-foreground cursor-pointer">
                <Send className="h-4 w-4" />
                <span className="sr-only">Подписаться</span>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-border/30" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs text-muted-foreground/60">
          <p>
            &copy; {currentYear} Агенство ПРОФИ. Все права защищены.
          </p>
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Политика конфиденциальности
            </Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">
              Условия использования
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}